<template>
  <div class="competition-rank-list-wrapper">
    <a class="back" @click="$router.go(-1)">
      <img
        src="@/assets/icons/backArrow2.png"
        style="margin-right: 10px;"
        alt=""
      />
      {{ $t('competitions.tr.backToRangList') }}
    </a>
    <h1 v-html="$t('competitions.tr.pageInstitutionUnavailable')"></h1>
  </div>
</template>

<script>
export default {
  name: 'CompetitionNoScool'
}
</script>

<style lang="scss" scoped>
.competition-rank-list-wrapper {
  margin: 0 auto;
  position: relative;
  max-width: 1320px;
  width: calc(100% - 40px);
  padding-top: 30px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h1 {
    font-weight: 500;
    font-size: 38px;
    line-height: 52px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 0;
    margin-bottom: 10px;
    text-align: left;
  }
  p {
    font-weight: 400;
    font-size: 20px;
    line-height: 194.9%;
    margin-bottom: 20px;
  }

  .back {
    font-weight: 500;
    font-size: 20px;
    line-height: 25px;
    color: rgba(140, 140, 140, 0.96);
    cursor: pointer;
    text-decoration: none;
    margin-bottom: 50px;
    text-align: left;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
}
@media only screen and (max-width: 1024px) {
  .competition-rank-list-wrapper {
    h1 {
      width: 100%;
      margin-bottom: 20px;
      font-size: 28px;
      line-height: 36px;
    }
  }
}
</style>
